<template>
    <div class="widget-inner">
        <template v-if="isPersonalDashboardWidget">
            <template v-if="entries.length">
                <div class="padding-5">
                    <div class="font-size-16 text-success padding-bottom-2">
                        <strong>Heute, {{dateHelper('d.m.Y')}}</strong>
                    </div>

                    <div v-for="entry of entries" :class="['margin-bottom-8 flex-vertical-stretch', {'bottom-border': entry !== entries[entries.length - 1]}]">
                        <div class="calendar-category" :style="{'background-color': buildColor(entry.category_color) }"></div>

                        <div class="flex-grow">
                            <div class="font-size-13 flex-vertical-middle">
                                <span v-tooltip :title="entry.timeToolTip">{{entry.timeString}}</span>

                                <router-link :to="buildLink(entry)" class="appointment-title">
                                    {{entry.title}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div v-else class="widget-empty-message">
                <div :style="{color}">
                    {{widget.emptyMessage}}
                </div>
            </div>
        </template>
        <template v-else>
            <div class="widget-empty-message" v-if="!entries.length">
                <i class="material-icons md-96" aria-hidden="true" role="img">{{widget.emptyIcon}}</i>
                <br/>
                {{widget.emptyMessage}}
            </div>
            <ul class="widget-content" v-else>
                <li class="flex" :class="{'background-today': isToday(entry.recurrence_start)}" v-for="entry in entries">
                    <div class="flex" style="align-items: center;margin-right: 10px; flex-direction: column;">
                        {{dateHelper('d.m.Y', entry.recurrence_start)}}
                        <br/>
                        <small>
                            <template v-if="entry.entry_start_time === '00:00:00' && entry.entry_end_time === '24:00:00' || entry.all_day">
                                ganztägig
                            </template>
                            <template v-else-if="entry.entry_start_time">
                                <template v-if="entry.recurrence_start === entry.recurrence_end && entry.entry_end_time">
                                    {{entry.entry_start_time.slice(0, 5) + ' - ' + entry.entry_end_time.slice(0, 5)}}
                                </template>
                                <template v-else>
                                    Ab {{entry.entry_start_time.slice(0, 5)}} Uhr
                                </template>
                            </template>
                        </small>
                    </div>
                    <div class="text-overflow">
                        <router-link :to="buildLink(entry)">{{entry.title}}</router-link>
                        <small v-if="entry.calendar_title">{{entry.calendar_title}}</small>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts">
    import {WidgetCalendarDefault} from './WidgetCalendarDefault.vue';
    import {Component} from 'vue-facing-decorator';

    @Component({
        name: 'WidgetAppointment',
        methods: {},
    })
    export class WidgetAppointment extends WidgetCalendarDefault<IWidgetCalendarDefaultEntry>
    {
    }

    export default WidgetAppointment;
</script>